document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-elivora-faq]').forEach((faq) => {
    faq.querySelectorAll('.eh-faq__question').forEach((button) => {
      button.addEventListener('click', () => {
        const item = button.closest('.eh-faq__item');
        if (!item) return;
        const isOpen = item.classList.contains('is-open');

        faq.querySelectorAll('.eh-faq__item').forEach((other) => {
          other.classList.remove('is-open');
          const otherBtn = other.querySelector('.eh-faq__question');
          if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          item.classList.add('is-open');
          button.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });
});
